import { useMutation, useQueryClient } from '@tanstack/react-query';
import api from '../lib/api.js';

export function useTransactionVatMutation() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, vat_rate, vat_amount_cents }) =>
      api.patch(`/transactions/${id}/vat`, { vat_rate, vat_amount_cents }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['transactions'] });
      qc.invalidateQueries({ queryKey: ['cash-flow'] });
    },
  });
}
